const disabledMonthlyRewardsAddresses = [
    "0xd6D51119fFE9DDf2068B0997D35Ff9C4f1C8bB67",
    "0x78daC2dD4aCCd20e2aB67A93Da2592ABA0693077",
].map((address) => address.toLowerCase());

// For stake a, n, 4, 1

export const isMonthlyRewardsDisabled = (address) =>
    !!address && disabledMonthlyRewardsAddresses.includes(address.toLowerCase());

export default disabledMonthlyRewardsAddresses;
